<template>
    <div class="flex-column">
        <div>
            <el-tree
                :data="filter.inputs.choices.options"
                ref="tree"
                show-checkbox
                node-key="id"
                @check="handleCheckChange"
                :default-checked-keys="this.choices"
                :props="defaultProps"
            >
                <template #default="{ data }">
                    <span>
                        <el-tooltip effect="dark" :content="data.name" placement="top">
                            <span>{{ data.name }}</span>
                        </el-tooltip>
                    </span>
                </template>
            </el-tree>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],
    data() {
        return {
            choices: [],
            defaultProps: {
                children: 'children',
                label: 'name',
            },
        };
    },
    computed: {
        data() {
            return {
                choices: this.choices,
            };
        },
    },

    methods: {
        handleCheckChange(data, checked, indeterminate) {
            this.choices = this.$refs.tree.getCheckedKeys();
        },
    },
};
</script>
